import clsx from "clsx";
import { UnderlinedSectionHeader, CarouselCards } from "@components";

export default function Data({ cards, bg = "bg-green", subheader, header = "Data" }) {
    return (
        <div className={parentContainerStyle}>
            <UnderlinedSectionHeader className="max-w-[700px]">
                {header}
            </UnderlinedSectionHeader>
            <div className={subheaderStyle}>{subheader}</div>
            <div className="w-full">
                <CarouselCards cards={cards} bg={bg}/>
            </div>
        </div>
    );
}

const parentContainerStyle = clsx(
    "w-full flex flex-col items-center justify-center mt-20 md:mt-40",
);
const subheaderStyle = clsx("my-10 text-center text-lg md:text-2xl mx-8");

Data.prototypes = {
    cards: Array,
    subheader: String,
};
